<template>
  <v-container class="ma-0 pa-0" style="height: 100%">
    <div class="ma-0 pa-0" align-items="center" flat max-width="500">
      <v-form ref="changePassForm" lazy-validation class="px-3 pb-3 pt-0 mt-0">
        <v-text-field class="my-3" v-model="pass" autofocus autocomplete="current-password" :prepend-icon="passVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'" :rules="[requiredPass]" :type="passVisible ? 'text' : 'password'" name="currentPassword" :label="s_CurrentPassword" counter @click:prepend="passVisible = !passVisible"></v-text-field>
        <v-text-field class="my-3" v-model="newPass" autocomplete="new-password" :prepend-icon="passVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'" :rules="[requiredNewPass, ruleNewPassLength]" :type="passVisible ? 'text' : 'password'" name="newPassword" :label="s_NewPassword" counter @click:prepend="passVisible = !passVisible"></v-text-field>
        <v-text-field class="my-3" v-model="newPassConfirm" autocomplete="new-password" :prepend-icon="passVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'" :rules="[passwordConfirmationRule]" :type="passVisible ? 'text' : 'password'" name="newPassConfirm" :label="s_ConfirmPassword" counter @click:prepend="passVisible = !passVisible"></v-text-field>
        <v-row class="ma-0 pa-0">
          <!-- <v-spacer></v-spacer> -->
          <t-button :btnDisabled="isSaveDisabled" :btnIcon="'mdi-account-key-outline'" :btnText="s_Change" @click.native="changePassword" />
        </v-row>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { TR } from "../../main";

export default {
  data() {
    return {
      isSaveDisabled: false,
      pass: "",
      newPass: "",
      newPassConfirm: "",
      passVisible: false,
      s_Change: TR.Change,
      s_CurrentPassword: TR.CurrentPassword,
      s_NewPassword: TR.NewPassword,
      s_ConfirmPassword: TR.ConfirmPassword,
    };
  },
  computed: {
    ruleNewPassLength() {
      return this.newPass.length >= 6 || TR.PasswordMin6Symbols;
    },
    requiredPass() {
      return !!this.pass || TR.PasswordRequired;
    },
    requiredNewPass() {
      return !!this.newPass || TR.PasswordNewRequired;
    },
    passwordConfirmationRule() {
      return this.newPass === this.newPassConfirm || TR.PasswordsDoesntMatch;
    },
  },
  methods: {
    changePassword() {
      if (this.$refs.changePassForm.validate()) {
        this.isSaveDisabled = true;
        DataManager.changeUserPassword({ userName: DataManager.getData(DataManager.DataType.user, true).userName, oldPassword: this.pass, newPassword: this.newPass, newConfirmPassword: this.newPassConfirm }, (error) => {
          if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            this.dialogLoader.showInfo(TR.SaveSuccessful);
            this.pass = "";
            this.newPass = "";
            this.newPassConfirm = "";
            this.$refs.changePassForm.reset();
          } else {
            this.dialogLoader.showError(error.Message);
          }
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 3000);
        });
      }
    },
    close() {
      bus.$emit(bus.EVENT_Close_ChangePass);
    },
  },
};
</script>

<style scoped>
</style>